export enum StreamingEvent {
    MessageDelta = 'MessageDelta',
    AssistantEvent = 'AssistantEvent',
    NewStreamedMessage = 'NewStreamedMessage',
    MessageRetry = 'MessageRetry',
    SkippedUnsupportedFile = 'SkippedUnsupportedFile',
}
